if (!customElements.get('glupota-mobile-menu')) {
  class GlupotaMobileMenu extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.toggle = this.querySelector('[data-menu-toggle]');
      this.toggleLabel = this.querySelector('[data-menu-label]');
      this.overlay = this.querySelector('[data-menu-overlay]');

      if (!this.toggle || !this.toggleLabel || !this.overlay) return;

      this.initialized = true;
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.handleToggle = this.handleToggle.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleBreakpoint = this.handleBreakpoint.bind(this);

      this.toggle.addEventListener('click', this.handleToggle);
      document.addEventListener('keydown', this.handleKeydown);
      this.desktopQuery.addEventListener('change', this.handleBreakpoint);
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.toggle.removeEventListener('click', this.handleToggle);
      document.removeEventListener('keydown', this.handleKeydown);
      this.desktopQuery.removeEventListener('change', this.handleBreakpoint);

      if (this.isOpen) this.close({ restoreFocus: false });
      this.initialized = false;
    }

    get isOpen() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    get focusableElements() {
      return [
        this.toggle,
        ...this.overlay.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      ].filter((element) => !element.hidden);
    }

    handleToggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    handleKeydown(event) {
      if (!this.isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = this.focusableElements;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    handleBreakpoint(event) {
      if (event.matches && this.isOpen) this.close({ restoreFocus: false });
    }

    open() {
      this.lastFocused = document.activeElement;
      this.scrollPosition = window.scrollY;
      this.previousBodyStyles = {
        overflow: document.body.style.overflow,
        position: document.body.style.position,
        top: document.body.style.top,
        width: document.body.style.width,
      };

      this.toggle.setAttribute('aria-expanded', 'true');
      this.toggleLabel.textContent = 'Close';
      this.overlay.hidden = false;

      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';

      const firstMenuLink = this.overlay.querySelector('a[href], button:not([disabled])');
      if (firstMenuLink) {
        firstMenuLink.focus();
      } else {
        this.toggle.focus();
      }
    }

    close({ restoreFocus = true } = {}) {
      this.toggle.setAttribute('aria-expanded', 'false');
      this.toggleLabel.textContent = 'Menu';
      this.overlay.hidden = true;

      if (this.previousBodyStyles) {
        document.body.style.overflow = this.previousBodyStyles.overflow;
        document.body.style.position = this.previousBodyStyles.position;
        document.body.style.top = this.previousBodyStyles.top;
        document.body.style.width = this.previousBodyStyles.width;
        window.scrollTo(0, this.scrollPosition);
      }

      if (restoreFocus) this.lastFocused?.focus();
    }
  }

  customElements.define('glupota-mobile-menu', GlupotaMobileMenu);
}
